import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import FormikControl from "../../componenets/FormikReusable/FormikControl";
import { CustomInputComponent } from "./common/CustomInput";

const CourseEnrollment = () => {
  const options = [
    { key: "select your course", value: "" },
    { key: "HTML", value: "html" },
    { key: "CSS", value: "css" },
    { key: "Javascript", value: "js" },
  ];
  const skilloptions = [
    { key: "HTML", value: "html" },
    { key: "CSS", value: "css" },
    { key: "Javascript", value: "js" },
  ];
  const initialValues = {
    firstName: "",
    email: "",
    bio: "",
    course: "",
    skills: [],
    courseDate: null,
  };

  const validationSchema = Yup.object({
    firstName: Yup.string().required(),
    email: Yup.string().required().email("Invalid Email Format"),
    bio: Yup.string().required("Required"),
    course: Yup.string().required("Required"),
    courseDate: Yup.date().required("required").nullable(),
  });
  const onSubmit = (values) => {
    console.log("Form Data", values);
  };
  return (
    <>
      <h1 className="text-center">Student Enrollment Form</h1>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        validateOnMount
      >
        {(formik) => {
          return (
            <div
              className="container shadow "
              style={{ marginTop: "25px", width: "500px" }}
            >
              <Form>
                <Field
                  name="firstName"
                  component={CustomInputComponent}
                ></Field>

                <FormikControl
                  control="input"
                  type="email"
                  label="Email"
                  name="email"
                />
                <FormikControl control="textarea" label="bio" name="bio" />
                <FormikControl
                  control="select"
                  label="Course"
                  name="course"
                  options={options}
                />
                <FormikControl
                  control="checkbox"
                  label="Skills"
                  name="skills"
                  options={skilloptions}
                />
                <br />
                <FormikControl
                  control="date"
                  label="CourseDate"
                  name="courseDate"
                />
                <br />
                <button
                  type="submit"
                  style={{ margin: "10px" }}
                  disabled={!(formik.isValid || formik.isSubmitting)}
                >
                  Submit
                </button>
              </Form>
            </div>
          );
        }}
      </Formik>
    </>
  );
};

export default CourseEnrollment;
